import { AreaDTO } from './AreaDTO'
import { VenueClosureDTO } from '@services/DTO/VenueClosureDTO'

export class AreaScheduleDTO {

    constructor(
        public area: AreaDTO,
        public closures: VenueClosureDTO[]
    ) { }
}
